import { useMutation } from '@tanstack/react-query';
import type { LiveCallListenResponse } from '@vagusx/clients';
import { getInteractionClient } from '@/lib/api-clients';

/**
 * Ask for permission to listen to a call in progress.
 *
 * A mutation rather than a query, and deliberately: the request WRITES an
 * audit entry — hearing live patient audio is an access event the practice
 * has to be able to account for — so it must not be cached, retried on a
 * whim, or refetched on focus. One press, one recorded listen.
 *
 * The token it returns is short-lived and grants access to live patient
 * audio. Hold it in component state for the life of the listening session
 * and never persist it.
 */
export function useListenToCall() {
  return useMutation<LiveCallListenResponse, Error, string>({
    mutationFn: (interactionId: string) => getInteractionClient().listenToCall(interactionId),
  });
}
